import { useEffect } from "react";

const BASE_URL = "https://workandyou-independant.lovable.app";

const setMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const usePageMeta = (opts: { title: string; description: string; path: string; noindex?: boolean }) => {
  useEffect(() => {
    document.title = opts.title;
    setMeta("name", "description", opts.description);
    setMeta("property", "og:title", opts.title);
    setMeta("property", "og:description", opts.description);
    setMeta("property", "og:url", `${BASE_URL}${opts.path}`);
    setMeta("name", "robots", opts.noindex ? "noindex" : "index, follow");

    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${BASE_URL}${opts.path}`;
  }, [opts.title, opts.description, opts.path, opts.noindex]);
};
